export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7603.7d0984e2.jpg";